import { render } from "./announcements.vue?vue&type=template&id=7bc92c91"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"

import "./announcements.vue?vue&type=style&index=0&id=7bc92c91&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__